// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VE7a","title":"Header_title__2CaC8","left":"Header_left__1CKpJ","clinicName":"Header_clinicName__2MlNq"};